define('models/shared/network/network',["backbone",
        "models/causes/cause_collection"
], function (Backbone, AccountList) {
    var NetworkItem = Backbone.Model.extend({
        parse: function (data) {
            var response = {};
            response.AccountGUID = data.AG;
            response.AccountName = data.AN;
            response.AccountTypeID = data.ATID;
            response.Allocating = data.AL;
            response.HaveInCommon = data.HIC;
            response.Manage = data.M;
            response.ParticipantCount = data.PC;
            response.ConvNotificationThresholdExceeded = data.CNTE;
            response.NewsNotificationThresholdExceeded = data.NNTE;
            if (data.NA != null) {
                response.accounts = new AccountList(data.NA, {
                    parse: true
                });            
            }
            response.ManagerUserGUID = data.MUGD;
            response.PhotoName = data.PN;
            response.ManagerPhotoName = data.MPN;
            response.PhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.Account, data.AG, pf.enums.imageTypeGUIDEnum.Thumbnail, data.PN);
            response.ManagerPhotoURL = buildImageURL(pf.enums.entityTypeCodeEnum.User, data.MUGD, pf.enums.imageTypeGUIDEnum.Thumbnail, data.MPN);
            response.CertificationTypeID = data.CTID;
            response.CertificationImageName = data.CIN;
            if (data.CTID == 1 || data.CTID == 2)
                response.CertificateURL = "/img/" + data.CIN + ".png";
            else
                response.CertificateURL = "";
            response.isPrivate;
            return response;
        }
    });
    return NetworkItem;
});

